import {
  conversationFragment,
  widgetConversationFragment,
  allConversationFragments,
} from 'ducks/tickets/fragments'

export const ticketConversationsQuery = () => `
query TicketConversationsQuery($filter: ConversationFilter, $orderBy: ConversationOrder, $cursor: String, $size: Int){
  conversations(filter: $filter, orderBy: $orderBy, after: $cursor, first: $size) {
    nodes {
      ${allConversationFragments()}
    }
    totalCount
    totalPageCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
  }
}
${conversationFragment({ basic: true })}
${widgetConversationFragment()}
`

export const roomConversationsQuery = () => `
  query roomConversationsQuery($filter: RoomFilter, $cursor: String, $size: Int, $orderBy: RoomOrder ) {
    rooms(filter: $filter, after: $cursor, first: $size, orderBy: $orderBy) {
      totalCount
      totalPageCount
      nodes {
        id
        number
        contact {
          id
          name
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
    }
  }
`

const pinnedSearchPart = `
pinnedSearches(filter: $pinnedSearchFilter) {
  nodes {
    id
    queryId
    conversationCount
  }
}
`

export const ticketConversationCountForChannelQuery = ({
  canUsePinnedSearches,
}) => `
query TicketConversationCountForChannelQuery($channelId: ID!${
  canUsePinnedSearches ? ', $pinnedSearchFilter: PinnedSearchFilter!' : ''
}) {
  node(id: $channelId) {
    ... on Channel {
      folders (filter: { scope: CURRENT_USER, state: ACTIVE }) {
        nodes {
          id
          conversationCount
        }
      }
      tags (first: 20, orderBy: { field: CONVERSATION_COUNT, direction: DESC }, filter: { conversationStates: [UNREAD, OPENED], channelId: $channelId }) {
        nodes {
          id
          name
          color
          conversationCount(filter: { states: [UNREAD, OPENED] })
        }
      }
      permittedAgents {
        nodes {
          id
          conversationCount
        }
      }
      ${canUsePinnedSearches ? pinnedSearchPart : ''}
    }
  }
}
`

export const ticketConversationCountQuery = ({ canUsePinnedSearches }) => `
query TicketConversationCountQuery${
  canUsePinnedSearches ? '($pinnedSearchFilter: PinnedSearchFilter!)' : ''
} {
  channels {
    nodes {
      id
      conversationCount (state: [UNREAD, OPENED])
    }
  }
  folders (filter: { scope: CURRENT_USER, state: ACTIVE }) {
    nodes {
      id
      conversationCount
    }
  }
  tags (first: 20, orderBy: { field: CONVERSATION_COUNT, direction: DESC }, filter: { conversationStates: [UNREAD, OPENED] }) {
    nodes {
      id
      name
      color
      conversationCount(filter: { states: [UNREAD, OPENED] })
    }
  }
  agents {
    nodes {
      id
      conversationCount
    }
  }
  ${canUsePinnedSearches ? pinnedSearchPart : ''}
}
`

export const roomConversationCountForChannelQuery = () => `
query roomConversationCountForChannelQuery($channelId: ID, $channelType: RoomChannelTypeEnum!) {
  roomsCounts(channelId: $channelId, channelType: $channelType) {
    lastUpdatedAt
    data {
      id
      conversationCount
      unreadCount
    }
  }
}
`
